import React from 'react';
import { FaCalendarAlt, FaClock, FaUserCircle } from "react-icons/fa";
import CommentBackBg from "../../assets/images/commentBackBg.svg";
import "./Comments.scss";
import "./Respomsive.scss";

const Comments = (props) => {
    return (
        <div className="commentBox">
            <img className="backBg" src={CommentBackBg} alt="back" />
            {props.commentData.length <= 0 && (
                <p className="noComment">دیدگاهی برای نمایش وجود ندارد!</p>
            )}
            {props.commentData.map((item, index) => {
                return (
                    <div key={index} className="commentItem">
                        <p className="userName">
                            <span>
                                <FaUserCircle /> {item.userName}
                            </span>
                            <span>
                                <FaCalendarAlt /> {item.dateTime} <FaClock /> {item.dateTime}
                            </span>
                        </p>
                        <p className="userComment">{item.comment}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default React.memo(Comments)
